// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { signOut } from 'firebase/auth';
// import { auth } from 'firebase.config';

// // material-ui
// import { useTheme } from '@mui/material/styles';
// import { Fade, Button, ClickAwayListener, Paper, Popper, List, ListItemText, ListItemIcon, ListItemButton } from '@mui/material';

// // assets
// import PersonTwoToneIcon from '@mui/icons-material/PersonTwoTone';
// import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
// import MeetingRoomTwoToneIcon from '@mui/icons-material/MeetingRoomTwoTone';
// import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
// import EmailIcon from '@mui/icons-material/Email';

// // ==============================|| PROFILE SECTION ||============================== //

// const ProfileSection = () => {
//   const theme = useTheme();
//   const userData = localStorage.getItem('savedUsername');
//   // const users = (userData);
//   const userName = userData;
//   // const phoneNumber = users ? users.number : null;
//   // const user_email = users ? users.email : null;

//   const navigateTo = useNavigate();

//   const handleLogout = () => {
//     signOut(auth)
//       .then(() => {
//         localStorage.removeItem('userData');
//         localStorage.removeItem('phoneNumber');
//         navigateTo('/');
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   const [open, setOpen] = React.useState(false);
//   const anchorRef = React.useRef(null);

//   const handleToggle = () => {
//     setOpen((prevOpen) => !prevOpen);
//   };

//   const handleClose = (event) => {
//     if (anchorRef.current && anchorRef.current.contains(event.target)) {
//       return;
//     }
//     setOpen(false);
//   };

//   const prevOpen = React.useRef(open);
//   React.useEffect(() => {
//     if (prevOpen.current === true && open === false) {
//       anchorRef.current.focus();
//     }
//     prevOpen.current = open;
//   }, [open]);

//   if (!auth) {
//     return null;
//   }

//   return (
//     <>
//       <Button
//         sx={{ minWidth: { sm: 50, xs: 35 }, color: 'black' }}
//         ref={anchorRef}
//         aria-controls={open ? 'menu-list-grow' : undefined}
//         aria-haspopup="true"
//         aria-label="Profile"
//         onClick={handleToggle}
//         color="inherit"
//       >
//         <AccountCircleTwoToneIcon sx={{ fontSize: '1.7rem' }} />
//       </Button>
//       {true ? (
//         <Popper
//           placement="bottom-end"
//           open={open}
//           anchorEl={anchorRef.current}
//           role={undefined}
//           transition
//           disablePortal
//           modifiers={[
//             {
//               name: 'offset',
//               options: {
//                 offset: [0, 10]
//               }
//             },
//             {
//               name: 'preventOverflow',
//               options: {
//                 altAxis: true
//               }
//             }
//           ]}
//         >
//           {({ TransitionProps }) => (
//             <Fade {...TransitionProps}>
//               <Paper>
//                 <ClickAwayListener onClickAway={handleClose}>
//                   <List
//                     sx={{
//                       width: '100%',
//                       maxWidth: 350,
//                       minWidth: 250,
//                       bgcolor: theme.palette.background.paper,
//                       pb: 0,
//                       borderRadius: '10px'
//                     }}
//                   >
//                     <ListItemButton>
//                       <ListItemIcon>
//                         <PersonTwoToneIcon />
//                       </ListItemIcon>
//                       <ListItemText primary={userName} />
//                     </ListItemButton>
//                     <ListItemButton>
//                       <ListItemIcon>
//                         <LocalPhoneIcon />
//                       </ListItemIcon>
//                       {/* <ListItemText primary={phoneNumber} /> */}
//                     </ListItemButton>
//                     {true ? (
//                       <ListItemButton>
//                         <ListItemIcon>
//                           <EmailIcon />
//                         </ListItemIcon>
//                         {/* <ListItemText primary={user_email} /> */}
//                       </ListItemButton>
//                     ) : null}
//                     <ListItemButton onClick={handleLogout}>
//                       <ListItemIcon>
//                         <MeetingRoomTwoToneIcon />
//                       </ListItemIcon>
//                       <ListItemText primary="Logout" />
//                     </ListItemButton>
//                   </List>
//                 </ClickAwayListener>
//               </Paper>
//             </Fade>
//           )}
//         </Popper>
//       ) : (
//         <>No users found</>
//       )}
//     </>
//   );
// };

// export default ProfileSection;



import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from 'firebase.config';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Fade,
  Button,
  ClickAwayListener,
  Paper,
  Popper,
  List,
  ListItemText,
  ListItemIcon,
  ListItemButton
} from '@mui/material';

// assets
import PersonTwoToneIcon from '@mui/icons-material/PersonTwoTone';
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import MeetingRoomTwoToneIcon from '@mui/icons-material/MeetingRoomTwoTone';
// import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
// import EmailIcon from '@mui/icons-material/Email';

const ProfileSection = () => {
  const theme = useTheme();
  const userName = localStorage.getItem('savedUsername') || '';
  const navigateTo = useNavigate();

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => setOpen((prev) => !prev);
  const handleClose = (event) => {
    if (anchorRef.current && event && anchorRef.current.contains(event.target)) return;
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      // Sign out of Firebase if applicable (safe no-op otherwise)
      await signOut(auth).catch(() => {});
    } finally {
      // Clear the ONLY keys you actually store (per your screenshot)
      localStorage.removeItem('accessToken');
      localStorage.removeItem('savedUsername');
      localStorage.removeItem('user_id');

      setOpen(false);
      // Replace so back button doesn't return to a protected page
      navigateTo('/', { replace: true });

      // If any stale state persists due to caches, you can hard reload instead:
      // window.location.replace('/');
    }
  };

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current?.focus();
    }
    prevOpen.current = open;
  }, [open]);

  if (!auth) return null;

  return (
    <>
      <Button
        sx={{ minWidth: { sm: 50, xs: 35 }, color: 'black' }}
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        aria-label="Profile"
        onClick={handleToggle}
        color="inherit"
      >
        <AccountCircleTwoToneIcon sx={{ fontSize: '1.7rem' }} />
      </Button>

      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        modifiers={[
          { name: 'offset', options: { offset: [0, 10] } },
          { name: 'preventOverflow', options: { altAxis: true } }
        ]}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <List
                  sx={{
                    width: '100%',
                    maxWidth: 350,
                    minWidth: 250,
                    bgcolor: theme.palette.background.paper,
                    pb: 0,
                    borderRadius: '10px'
                  }}
                >
                  <ListItemButton>
                    <ListItemIcon>
                      <PersonTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText primary={userName || 'User'} />
                  </ListItemButton>

                  {/* <ListItemButton>
                    <ListItemIcon>
                      <LocalPhoneIcon />
                    </ListItemIcon>
                    <ListItemText primary={phoneNumber} />
                  </ListItemButton>

                  <ListItemButton>
                    <ListItemIcon>
                      <EmailIcon />
                    </ListItemIcon>
                    <ListItemText primary={user_email} />
                  </ListItemButton> */}

                  <ListItemButton onClick={handleLogout}>
                    <ListItemIcon>
                      <MeetingRoomTwoToneIcon />
                    </ListItemIcon>
                    <ListItemText primary="Logout" />
                  </ListItemButton>
                </List>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default ProfileSection;
